import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './config/amplify' // Initialize AWS Amplify
import './services/i18n' // Initialize i18n before the app
import App from './App.tsx'
import { Material3ThemeProvider } from './providers/Material3ThemeProvider'

const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
  </div>
);

createRoot(document.getElementById('root')!).render(
  // TEMPORARILY DISABLE StrictMode - causes infinite loops in dev
  // <StrictMode>
    <Material3ThemeProvider>
      <Suspense fallback={<LoadingFallback />}>
        <App />
      </Suspense>
    </Material3ThemeProvider>
  // </StrictMode>,
)
